import TruckImage from 'assets/images/psp/PSPHero/truck-hero.webp';
import TruckContent1 from 'assets/images/psp/truck-storage-options.webp';
import tenByTwenty from 'assets/images/icons/psp/10x20.svg';
import tenByThirty from 'assets/images/icons/psp/10x30.svg';
import tenByForty from 'assets/images/icons/psp/10x40.svg';
import Look1 from 'assets/images/icons/psp/look1.svg';
import Look2 from 'assets/images/icons/psp/look2.svg';
import Look3 from 'assets/images/icons/psp/look3.svg';
import Look4 from 'assets/images/icons/psp/look4.svg';
import Look5 from 'assets/images/icons/psp/look5.svg';
import Look6 from 'assets/images/icons/psp/look6.svg';
import TruckCard1 from 'assets/images/psp/FeaturedContentImages/vehicle1.webp';
import TruckCard2 from 'assets/images/psp/FeaturedContentImages/vehicle2.webp';
import TruckCard3 from 'assets/images/psp/FeaturedContentImages/vehicle3.webp';
import TruckCard4 from 'assets/images/psp/FeaturedContentImages/vehicle4.webp';
import { storageCategories } from '../utils/getPSPLinks';
const faqs = [
	{
		question: 'How much does pickup truck storage typically cost?',
		answer: 'Storage pickup truck costs vary by location and facility type, but you can expect to pay anywhere from $75-200 per month. Outdoor uncovered spaces are the most budget-friendly, while indoor or covered options cost more but offer better protection from weather and potential damage.',
	},
	{
		question: 'Do I need insurance for my truck?',
		answer: "Most storage facilities require you to maintain your own insurance. Check with your auto insurance provider. Many policies cover vehicles in storage, sometimes at reduced rates since the truck isn't being driven regularly.",
	},
	{
		question: 'Can I access my truck anytime I need it?',
		answer: 'This depends on the facility. Many modern storage locations offer 24/7 access, while others have specific hours. When comparing options, make sure the access schedule works with your lifestyle and any work requirements.',
	},
	{
		question:
			"What's the difference between indoor and outdoor truck storage?",
		answer: 'Outdoor storage is typically more affordable and offers drive-up convenience, but your truck is exposed to weather. Indoor storage provides maximum protection from elements and theft but costs more and may have limited availability.',
	},
	{
		question: 'How do I know if a storage facility is secure?',
		answer: "Look for facilities with gated access, security cameras, good lighting, and on-site management during business hours. Don't hesitate to visit in person and ask about their security measures. Reputable facilities are happy to discuss their safety protocols.",
	},
	{
		question:
			'Should I prepare my truck differently for long-term vs. short-term storage?',
		answer: 'Yes! For storage longer than 30 days, consider using a battery tender, adding fuel stabilizer, and slightly overinflating tires. For short-term storage (under a month), basic cleaning and fluid checks are usually sufficient.',
	},
	{
		question: "Can I store items inside my truck while it's in storage?",
		answer: "Policies vary by facility, but many allow you to store items inside your vehicle. However, avoid leaving anything valuable or temperature-sensitive, and check that your items won't affect your insurance coverage.",
	},
	{
		question:
			'What should I do if I need to store a work truck or commercial vehicle?',
		answer: 'Commercial truck storage may have different requirements and rates. Some facilities specialize in commercial vehicle storage and may offer features like vehicle prep areas or fleet discounts. Be upfront about commercial use when booking.',
	},
];

const reviews = [
	{
		id: '1',
		title: 'Great place if you need storage…',
		link: 'https://www.trustpilot.com/reviews/6564d94a739e813360f7d29a',
		text: "Great place if you need storage to store your items or even car or truck, and the price is very reasonable than the rest of the storage units I've looked at.",
		stars: 5,
		date: 'Nov 28, 2023',
		customerName: 'Willie Dunning',
		key: 'Willie Dunning',
	},
	{
		id: '2',
		title: 'Excellent site to store truck.',
		link: 'https://www.trustpilot.com/reviews/6365bdce252cba2c02cf7b91',
		text: 'The manager on site was relatively new. He was extremely helpful, friendly, knowledgeable, and professional. It is a great place to store my truck. I’d refer this place to friends, family.',
		stars: 5,
		customerName: 'Tracy L. Davis',
		key: 'Tracy L. Davis',
		date: 'Nov 5, 2022',
	},
	{
		id: 3,
		title: 'In time of need.',
		link: 'https://www.trustpilot.com/reviews/629a2dd2d5573095630a5136',
		text: 'I was in need of a place to store my truck asap, and with help of self storage.com I was able to accomplish that stress free.',
		stars: 5,
		customerName: 'Francisco Junior Lopez',
		key: 'Francisco Junior Lopez',
		date: 'Oct 26, 2022',
	},
	{
		id: 4,
		title: 'Rent a place for my truck',
		link: 'https://www.trustpilot.com/reviews/5fca6d505e693f0704a00ca1',
		text: 'Needed a place to store my truck and every experience on Internet and conversation was always Very pleasing',
		stars: 5,
		date: 'Dec 4, 2020',
		customerName: 'Anthony Fletcher',
		key: 'Anthony Fletcher',
	},
];

export const TruckContent = {
	type: 'Truck',
	reviews: reviews,
	sections: [
		{
			title: 'Truck Storage',
			background: 'default',
			modules: [
				{
					type: 'hero',
					props: {
						content: {
							title: 'Find Affordable Truck Self Storage',
							description:
								"Tired of your pickup truck taking up precious driveway space or worried about street parking tickets? From temporary relocations and downsizing projects to keeping your truck secure during extended work assignments, truck storage doesn't have to break the bank. \n\n" +
								'Smart storage solutions can protect your vehicle while freeing up space at home. With some research, you can find affordable options that give you peace of mind without the premium price tag.\n\n' +
								'**SelfStorage.com** makes it simple to compare pickup truck storage solutions in your area, so you can make the best choice for your needs and budget.',
							image: TruckImage,
							storageType: 'Truck',
							CTAtext: 'Find Truck Self Storage',
						},
					},
				},
			],
		},
		{
			title: 'Video section 1',
			background: 'blueGradient',
			modules: [
				{
					type: 'video',
					props: {
						content: {
							title: 'Understanding Your Truck Storage Options',
							description:
								"When you're looking for the perfect storage solution, it helps to know what's available. From basic outdoor spaces to covered facilities, pickup truck storage comes in several forms to match different budgets and protection needs. \n\n",
							imageSrc: TruckContent1,
							suffixText:
								'The key is finding the sweet spot between affordability and the level of security your truck requires.',
						},
					},
				},
			],
		},
		{
			title: 'Truck Storage Options',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Pick the Right Space for Your Truck',
						content:
							'**Pro tip:** Measure your truck (including mirrors and any accessories) before booking to ensure a comfortable fit.',
						cardData: [
							{
								title: '10x20',
								imageSrc: tenByTwenty,
								content:
									'Compact Pickup' +
									'\n\n' +
									'Perfect for smaller trucks like Toyota Tacoma or Nissan Frontier' +
									'\n\n' +
									'Starting around $75/month',
							},
							{
								title: '10x30',
								imageSrc: tenByThirty,
								content:
									'Standard Pickup' +
									'\n\n' +
									'Ideal for F-150, Silverado, or Ram 1500' +
									'\n\n' +
									'Starting around $95/month',
							},
							{
								title: '10x40',
								imageSrc: tenByForty,
								content:
									'Extended Cab' +
									'\n\n' +
									'Best for crew cab trucks or those with tool boxes' +
									'\n\n' +
									'Starting around $125/month',
							},
						],
					},
				},
			],
		},
		{
			title: 'Content Section 1',
			background: 'blueWithMap',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Preparing Your Truck for Storage',
						contentType: 'row-type',
						theme: 'dark',
						content: [
							`1. **Deep clean inside & out:**
				Wash exterior, vacuum interior, remove all food/trash
				Prevents pests, odors, and potential damage from spills or crumbs\n\n` +
								`2. **Check & top off fluids:**
				Oil, coolant, brake fluid, windshield washer fluid
				Prevents corrosion and ensures your truck starts smoothly when you return \n\n` +
								`3. **Fill gas tank:**
				Add fuel stabilizer and fill tank completely
				Prevents fuefl system issues and condensation in the tank\n\n` +
								`4. **Tire care:**
				Clean tires, slightly overinflate by 5-10 PSI
				Prevents flat spots from developing during long-term storage\n\n` +
								`5. **Battery maintenance:**
				Clean terminals, consider battery tender for long-term storage
				Keeps battery charged and prevents corrosion on terminals\n\n` +
								`6. **Ensure coverage:**
				Cover your truck with breathable, water-resistant fabric
				Protects your truck from the elements while allowing moisture to escape. \n\n` +
								`7. **Document condition:**
				Take photos of exterior, interior, and any existing damage
				Provides proof of pre-storage condition for insurance purposes \n\n` +
								`8. **Remove personal items:**
				Clear all belongings, registration/insurance docs
				Prevents theft and protects important documents\n\n` +
								`9. **Check insurance coverage:**
				Confirm your policy covers stored vehicles
				Ensures you're protected while your truck isn't being driven`,
						],
					},
				},
			],
		},
		{
			title: 'Truck Storage Options',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'What to Look for in Truck Storage Facilities',
						cardData: [
							{
								title: '24/7 Access',
								imageSrc: Look1,
								content:
									'Whether you need your truck for an early morning project or weekend adventure, flexible access keeps you in control.',
							},
							{
								title: 'Security Cameras',
								imageSrc: Look2,
								content:
									'Your truck is a significant investment. Facilities with surveillance give you (and your insurance company) extra peace of mind.',
							},
							{
								title: 'Gated Entry',
								imageSrc: Look3,
								content:
									'An extra barrier between your truck and potential problems. Look for facilities that require access codes or key cards.',
							},
							{
								title: 'Well-Lit Areas',
								imageSrc: Look4,
								content:
									'Good lighting deters unwanted activity and makes it safer for you to access your truck during early or late hours.',
							},
							{
								title: 'On-Site Management',
								imageSrc: Look5,
								content:
									'Having someone around during business hours means faster problem resolution and better facility maintenance.',
							},
							{
								title: 'Vehicle Prep Area',
								imageSrc: Look6,
								content:
									'Some facilities offer space to check fluids, clean, or do basic maintenance before taking your truck out of storage.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							headerTitle: 'Truck Self Storage: ',
							reviews,
						},
					},
				},
			],
		},
		{
			title: 'FAQ Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							faqs,
							header: 'Truck Self Storage FAQs',
						},
					},
				},
			],
		},
		{
			title: 'Featured Content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Learn All About Truck Self Storage',
							type: 'unitCards',
							data: {
								slug: 'storage-size-guide-unit-cards',
								unitCards: [
									{
										title: 'Storage Tips',
										date: 'March 3, 2025',
										image: TruckCard1,
										content:
											'Choosing the Right Storage Unit for Your Vehicle',
										url: 'https://www.selfstorage.com/blog/car-storage-size-guide/',
									},
									{
										title: 'Storage Tips',
										date: 'January 21, 2025',
										image: TruckCard2,
										content:
											'RV & Camper Winterization: Essential Steps',
										url: 'https://www.selfstorage.com/blog/rv-winterization-guide/',
									},
									{
										title: 'Storage Tips',
										date: 'September 9, 2025',
										image: TruckCard3,
										content:
											'RV Storage: Long-Term Storage Types & Tips to Prepare',
										url: 'https://www.selfstorage.com/blog/long-term-rv-storage-tips-2/',
									},
									{
										title: 'Storage Tips',
										date: 'October 3, 2025',
										image: TruckCard4,
										content:
											'Sports Equipment Storage Guide',
										url: 'https://www.selfstorage.com/blog/outdoor-gear-shed-storage-unit/',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						type: 'unitCards',
						id: 'storage size unit cards',
						linksList: storageCategories.truck,
					},
				},
			],
		},
		{
			title: 'Storage Near You',
			background: 'lighterBlue',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Truck',
					},
				},
			],
		},
	],
};
